<template>
  <div class="customerProfile-con px-20 py-20 border-box">
    <el-card class="box-card">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="员工姓名">
          <el-input v-model="formInline.employeeName" placeholder="员工姓名" clearable />
        </el-form-item>
        <el-form-item label="部门">
          <el-input v-model="formInline.dept" placeholder="部门" clearable />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="formInline.status" placeholder="全部状态" clearable style="width:140px">
            <el-option label="生效中" :value="0" />
            <el-option label="即将到期" :value="1" />
            <el-option label="已逾期" :value="2" />
            <el-option label="审批中" :value="5" />
            <el-option label="已驳回" :value="6" />
            <el-option label="已续签" :value="4" />
            <el-option label="已作废" :value="7" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="queryData">查询</el-button>
          <el-button @click="resetData">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <div class="operate py-20 border-box">
      <el-button type="success" @click="openAdd">新增合同</el-button>
    </div>

    <div class="table-con">
      <tableComponent :columns="columns" :tableData="dataList" @preSizeChange="childSizeChange"
        @preCurrentChange="childCurrentChange" :loading="loading" :pagination="pagination">
        <template #statusSlot="{ row }">
          <el-tag :type="statusTag(row.status)">{{ statusText(row.status) }}</el-tag>
        </template>
        <template #operate="{ row }">
          <template v-if="row.status === 5">
            <span style="color:#909399">审批中</span>
          </template>
          <template v-else-if="row.status === 6">
            <el-button type="text" @click="openResubmit(row)">重新提交</el-button>
            <el-button v-if="canVoid" type="text" style="color:#F56C6C" @click="voidItem(row)">作废</el-button>
          </template>
          <template v-else-if="row.status === 4">
            <el-button v-if="canVoid" type="text" style="color:#F56C6C" @click="voidItem(row)">作废</el-button>
          </template>
          <template v-else-if="row.status === 7">
            <span style="color:#909399">已作废</span>
          </template>
          <template v-else>
            <el-button type="text" @click="openEdit(row)">编辑</el-button>
            <el-button type="text" @click="openRenew(row)">续签</el-button>
            <el-button v-if="canVoid" type="text" style="color:#F56C6C" @click="voidItem(row)">作废</el-button>
          </template>
        </template>
      </tableComponent>
    </div>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="620px">
      <el-form ref="form" :model="form" :rules="rules" label-width="110px">
        <el-row :gutter="12">
          <el-col :span="12">
            <el-form-item label="员工姓名" prop="employeeName">
              <el-select v-model="form.employeeName" placeholder="请选择员工" filterable clearable style="width:100%" @change="onUserChange">
                <el-option v-for="u in userOptions" :key="u.id" :label="u.name" :value="u.name" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="部门" prop="dept">
              <el-input v-model="form.dept" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12">
          <el-col :span="12">
            <el-form-item label="岗位" prop="post">
              <el-input v-model="form.post" placeholder="如：后端工程师" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="合同编号" prop="contractNo">
              <el-input v-model="form.contractNo" placeholder="如 HT-2026-0001（留空自动生成）" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12">
          <el-col :span="12">
            <el-form-item label="合同类型" prop="contractTypeName">
              <el-select v-model="form.contractTypeName" placeholder="请选择" style="width:100%" @change="syncType">
                <el-option v-for="t in typeOptions" :key="t" :label="t" :value="t" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="单独提醒天数" prop="remindDays">
              <el-input v-model.number="form.remindDays" type="number" :min="1" placeholder="默认 30" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12">
          <el-col :span="12">
            <el-form-item label="开始日期" prop="startDate">
              <el-date-picker v-model="form.startDate" type="date" format="yyyy-MM-dd" style="width:100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="结束日期" prop="endDate">
              <el-date-picker v-model="form.endDate" type="date" format="yyyy-MM-dd" style="width:100%" :disabled="endDisabled" />
              <div v-if="endHint" style="color:#999;font-size:12px;line-height:1.4;margin-top:4px">{{ endHint }}</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="备注">
          <el-input v-model="form.remark" type="textarea" :rows="2" placeholder="可选" />
        </el-form-item>
        <el-form-item label="合同附件" prop="attachment">
          <upload :item="uploadObj" :defaultFileList="parseFileList(form.attachment)"
            @dataFile="(fileList) => form.attachment = fileList" />
          <div style="color:#999;font-size:12px;margin-top:4px">支持任意格式，可多选</div>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submit">确定</el-button>
      </div>
    </el-dialog>

    <renew-dialog :row="renewRow" :visible.sync="renewVisible" @success="queryData" />
  </div>
</template>

<script>
import tableComponent from '@/components/tableComponent/index.vue'
import {
  pageForMyApi, addLaborContractApi, updateLaborContractApi,
  voidLaborContractApi, resubmitLaborContractApi
} from '@/api/laborContract/index'
import { userListNoAdmin } from '@/api/sys/user'
import upload from '@/components/upload/index.vue'
import renewDialog from './components/RenewDialog.vue'

export default {
  name: 'LaborContracts',
  components: { tableComponent, upload, renewDialog },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      dialogTitle: '新增合同',
      resubmitMode: false,
      formInline: { employeeName: '', dept: '', status: '' },
      renewVisible: false,
      renewRow: null,
      userOptions: [],
      form: this.emptyForm(),
      typeOptions: ['固定期限', '无固定期限', '实习协议', '劳务协议', '以完成一定工作任务为期限'],
      uploadObj: {
        key: 'attachment',
        uploadType: 'project',
        accept: '*',
        limit: 10,
        fileMaxSize: 200,
        disabled: false
      },
      dataList: [],
      columns: [
        { id: 0, title: '序号', isSort: false, width: '60px', keyName: 'i', align: 'center', slotName: '' },
        { id: 1, title: '合同编号', isSort: false, width: '150px', keyName: 'contractNo', align: 'left', slotName: '' },
        { id: 2, title: '员工姓名', isSort: false, width: '100px', keyName: 'employeeName', align: 'center', slotName: '' },
        { id: 3, title: '部门', isSort: false, width: '120px', keyName: 'dept', align: 'center', slotName: '' },
        { id: 4, title: '岗位', isSort: false, width: '120px', keyName: 'post', align: 'center', slotName: '' },
        { id: 5, title: '合同类型', isSort: false, width: '110px', keyName: 'contractTypeName', align: 'center', slotName: '' },
        { id: 6, title: '开始日期', isSort: false, width: '120px', keyName: 'startDate', align: 'center', slotName: '' },
        { id: 7, title: '结束日期', isSort: false, width: '120px', keyName: 'endDate', align: 'center', slotName: '' },
        { id: 8, title: '状态', isSort: false, width: '100px', keyName: 'status', align: 'center', slotName: 'statusSlot' },
        { id: 9, title: '操作', fixed: 'right', isSort: false, width: '200px', keyName: '', align: 'left', slotName: 'operate' }
      ],
      pagination: { pageCount: 7, total: 0, pageSize: 10, pageSizes: [10, 20, 100] }
    }
  },
  computed: {
    endDisabled() {
      return this.form.contractTypeName === '无固定期限'
    },
    endHint() {
      if (this.form.contractTypeName === '无固定期限') return '无固定期限合同无到期日，不纳入到期提醒'
      if (this.form.contractTypeName === '以完成一定工作任务为期限') return '以完成任务为期限：可填「预计完成日」用于到期提醒，留空则不提醒'
      return ''
    },
    // 仅行政(roleKey=xz) / 超级管理员(roleKey=admin) 可作废合同；财务(cwyg/cwbz)/总经理(zjl) 不可见作废按钮
    canVoid() {
      const roles = this.$store.getters.roles || []
      const account = this.$store.state.user.account
      const isAdmin = roles.includes('admin') || account === 'admin'
      const isXz = roles.includes('xz')
      return isAdmin || isXz
    },
    isAdd() {
      return !this.form.id
    },
    rules() {
      const r = {
        employeeName: [{ required: true, message: '请选择员工', trigger: 'change' }],
        dept: [{ required: true, message: '请输入部门', trigger: 'blur' }],
        post: [{ required: true, message: '请输入岗位', trigger: 'blur' }],
        contractNo: [{ required: true, message: '请输入/确认合同编号', trigger: 'blur' }],
        contractTypeName: [{ required: true, message: '请选择合同类型', trigger: 'change' }],
        startDate: [{ required: true, message: '请选择开始日期', trigger: 'change' }],
        endDate: [{ validator: this.validateEnd, trigger: 'change' }],
        remindDays: [{ required: true, message: '请输入提前提醒天数', trigger: 'blur' }],
        attachment: [{ validator: this.validateAttachment, trigger: ['change', 'blur'] }]
      }
      // 仅新增时强制上传附件；编辑历史无附件记录不强制
      if (!this.isAdd) r.attachment = []
      return r
    }
  },
  mounted() {
    this.loadUsers()
    this.applyQueryStatus()
    this.queryData()
  },
  watch: {
    // 从看板带 status 参数跳回本页时（可能被 keep-alive 缓存，mounted 不重新触发）自动套用筛选
    '$route'(to) {
      if (to.path === '/laborContract/contracts') {
        this.applyQueryStatus()
        this.queryData()
      }
    }
  },
  methods: {
    emptyForm() {
      return {
        id: null, contractNo: '', employeeName: '', dept: '', post: '',
        contractTypeName: '', contractTypeCode: '', startDate: null, endDate: null, attachment: '',
        remark: '', remindDays: null, sourceContractId: null
      }
    },
    fmt(date) {
      if (!date) return null
      const d = date instanceof Date ? date : new Date(date)
      const p = n => (n < 10 ? '0' + n : '' + n)
      return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate())
    },
    toDate(str) {
      if (!str) return null
      const d = new Date(str + 'T00:00:00')
      return isNaN(d.getTime()) ? null : d
    },
    // 看板下钻：用 URL 上的 ?status= 预置状态筛选；无参数则查全部
    applyQueryStatus() {
      const s = this.$route.query.status
      if (s !== undefined && s !== null && s !== '') {
        const n = Number(s)
        this.formInline.status = isNaN(n) ? '' : n
      } else {
        this.formInline.status = ''
      }
    },
    queryData() { this.initData() },
    loadUsers() {
      userListNoAdmin({}).then(res => {
        if (res.code === 200) {
          this.userOptions = res.data || []
        }
      })
    },
    onUserChange(name) {
      const u = this.userOptions.find(x => x.name === name)
      this.form.dept = u && u.deptName ? u.deptName : ''
    },
    parseFileList(val) {
      if (!val) return []
      let arr = val
      if (typeof val === 'string') {
        try {
          arr = JSON.parse(val)
        } catch (e) {
          return []
        }
      }
      if (!Array.isArray(arr)) return []
      return arr
    },
    initData(item = {}) {
      const params = {
        pageNum: '1', pageSize: '10',
        query: {
          employeeName: this.formInline.employeeName,
          dept: this.formInline.dept,
          status: (this.formInline.status === '' || this.formInline.status == null) ? null : Number(this.formInline.status)
        },
        ...item
      }
      this.loading = true
      pageForMyApi(params).then(res => {
        this.loading = false
        if (res.code == 200) {
          this.dataList = res.data.rows
          this.pagination.total = res.data.total
        }
      })
    },
    childSizeChange(page) { this.initData({ pageSize: page }) },
    childCurrentChange(value) { this.initData({ pageNum: value }) },
    resetData() {
      this.formInline.employeeName = ''
      this.formInline.dept = ''
      this.formInline.status = ''
      this.queryData()
    },
    openAdd() {
      this.dialogTitle = '新增合同'
      this.resubmitMode = false
      this.form = this.emptyForm()
      // 预填默认值，必填项默认即有值（用户可改）；合同编号留空将在提交时自动生成
      this.form.contractNo = 'HT-' + new Date().getTime()
      this.form.remindDays = 30
      this.form.startDate = new Date()
      this.dialogVisible = true
    },
    openEdit(row) {
      this.dialogTitle = '编辑合同'
      this.resubmitMode = false
      const f = { ...row }
      f.startDate = this.toDate(row.startDate)
      f.endDate = this.toDate(row.endDate)
      this.form = f
      this.dialogVisible = true
    },
    openRenew(row) {
      this.renewRow = row
      this.renewVisible = true
    },
    openResubmit(row) {
      this.dialogTitle = '重新提交审批'
      this.resubmitMode = true
      const f = { ...row }
      f.startDate = this.toDate(row.startDate)
      f.endDate = this.toDate(row.endDate)
      this.form = f
      this.dialogVisible = true
    },
    syncType(val) {
      this.form.contractTypeName = val
      this.form.contractTypeCode = val
      if (val === '无固定期限') this.form.endDate = null
    },
    validateEnd(rule, value, callback) {
      const t = this.form.contractTypeName
      if (t === '无固定期限' || t === '以完成一定工作任务为期限') return callback()
      if (!this.form.endDate) return callback(new Error('请选择结束日期'))
      callback()
    },
    validateAttachment(rule, value, callback) {
      const list = this.parseFileList(this.form.attachment)
      if (!list || list.length === 0) return callback(new Error('请上传合同附件'))
      callback()
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          this.$message.warning('请完整填写必填项（备注除外）')
          return
        }
        if (!this.form.contractNo) {
          this.form.contractNo = 'HT-' + new Date().getTime()
        }
        if (!this.form.startDate) {
          this.form.startDate = new Date()
        }
        const payload = {
          ...this.form,
          startDate: this.fmt(this.form.startDate),
          endDate: this.form.endDate ? this.fmt(this.form.endDate) : null
        }
        const api = this.resubmitMode ? resubmitLaborContractApi : (this.form.id ? updateLaborContractApi : addLaborContractApi)
        api(payload).then(res => {
          if (res.code == 200) {
            this.$message.success(this.resubmitMode ? '已重新提交，等待审批' : (this.form.id ? '保存成功' : '已提交，等待审批'))
            this.dialogVisible = false
            this.resubmitMode = false
            this.queryData()
          } else {
            this.$message.warning(res.msg)
          }
        })
      })
    },
    voidItem(row) {
      this.$confirm('确定作废该合同？记录将保留，状态标记为「作废」。', '提示', {
        confirmButtonText: '确定作废', cancelButtonText: '取消', type: 'warning'
      }).then(() => {
        voidLaborContractApi({ id: row.id }).then(res => {
          if (res.code == 200) {
            this.$message.success('已作废')
            this.queryData()
          } else {
            this.$message.warning(res.msg)
          }
        })
      }).catch(() => {})
    },
    statusText(s) { return ['生效中', '即将到期', '已逾期', '已解除', '已续签', '审批中', '已驳回', '作废'][s] || '-' },
    statusTag(s) { return ['success', 'warning', 'danger', 'info', 'info', 'warning', 'danger', 'info'][s] || 'info' }
  }
}
</script>
